import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, TemplateRef } from '@angular/core';
import * as _ from 'lodash';
import { OverlayPanel } from 'primeng/overlaypanel';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { Tab } from '../../../core/model/tab.model';
import { ConfigService } from '../../../core/services/config.service';
import { TerminalSummary } from './../../../core/model/terminal-summary.model';

@Component({
  selector: 'lms-terminal-status-carousel',
  templateUrl: './terminal-status-carousel.component.html',
  styleUrls: ['./terminal-status-carousel.component.scss']
})
export class TerminalStatusCarouselComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() childElementWidth: number;

  @Input() childElementHeight: number;

  @Input() firstVisible: number;

  @Input() header: string;

  @Input() label: string;

  @Input() value: any[];

  @Input() tab: Tab;

  @Output() headerDblClick = new EventEmitter<any>();

  @Output() locoClick = new EventEmitter<any>();

  @Output() terminalClick = new EventEmitter<any>();

  @Output() showLocoContextMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();

  @Output() hideContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() terminalSummary: TerminalSummary;

  @Input() yardLocalStationSummary: any;

  @Input() statusHeader: string;
 
  dataWidth: number;

  terminalOverlay: OverlayPanel;

  configData: any;

  lococlickdoubleclick = {
    delay: 500,
    timer: null,
    counter: 0
  };
  getNumberOfItemVisible: number;

  startIndex = 0;

  endIndex = 0;

  displayedItems: any[] = [];

  isPartialItemAvailable: boolean;

  public itemTemplate: TemplateRef<any>;

  constructor(renderer: Renderer2, private configService: ConfigService) {
    this.configData = this.configService.getConfigData();
    renderer.listen('window', 'resize', (event) => {
      this.calcuateDataWidth();
    });
  }

  /**
   * This shows Locomotive Context Menu
   * @param {TrainData} train
   * @param {LocoDetail} loco
   * @memberOf LmsTerminalBoundComponent
   */
  public showLocomotiveContextMenu(loco: LocoDetail) {
    if (this.terminalOverlay) {
      this.terminalOverlay.hide();
    }
    if (this.isContextMenuAvailable(loco)) {
      const locoMenu = new Map<string, any>();
      if (loco && loco.locomotiveIdentifier && loco.locomotiveIdentifier.length > 5) {
        locoMenu.set('locoData', loco);
        locoMenu.set('header', this.label);
        locoMenu.set('headerName', this.statusHeader);
        this.showLocoContextMenu.emit(locoMenu);
      }
    }
  }

  /**
   * @private
   * @param {LocoDetail} locomotive
   * @returns
   *
   * @memberOf LmsTerminalBoundComponent
   */
  private isContextMenuAvailable(locomotive: LocoDetail) {
    if (locomotive && locomotive.locomotiveIdentifier) {
      if (locomotive.locomotiveIdentifier.toUpperCase() === 'ZZZZZZZZZZZZZZ') {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  /**
   * This method is used to close the context panel
   * of train or locomotive
   * @memberOf LmsTerminalBoundComponent
   */
  public hideLocoTrainContextPanel() {
    this.hideContextMenu.emit(true);
  }

  /**
   * this method is use to open terminal popup
   */
  openTerminalPopup() {
    this.lococlickdoubleclick.counter++;
    this.lococlickdoubleclick.timer = setTimeout((data) => {
      if (this.label === 'ON TERMINAL') {
        this.terminalClick.emit();
      }
      this.lococlickdoubleclick.counter = 0;
      clearInterval(this.lococlickdoubleclick.timer);
    }, this.lococlickdoubleclick.delay);
  }
  /**
   * this method is used to calcuate data Width
   * then we set no of visible items
   * @memberof LmsCarouselComponent
   */
  calcuateDataWidth() {
    setTimeout(() => {
      // Here we have excluded the width of header i.e. 150px, width of navigation i.e. 60px and 5px(extra)
      if (document.getElementsByClassName('terminal-wrapper') && document.getElementsByClassName('terminal-wrapper').length > 0) {
        this.dataWidth = document.getElementsByClassName('terminal-wrapper')[0].clientWidth - 235;
        this.getNumberOfItemVisible = Math.ceil(this.dataWidth / this.childElementWidth);
        this.isPartialItemAvailable = Math.floor(this.dataWidth / this.childElementWidth) !== Math.ceil(this.dataWidth / this.childElementWidth);
        if (this.getNumberOfItemVisible <= 0) {
          this.getNumberOfItemVisible = 0;
          this.isPartialItemAvailable = false;
        }
        this.adjustDisplayArray();
      }
    }, 2);
  }

  /**
   * here do some setting to display items
   * @memberof LmsCarouselComponent
   */
  adjustDisplayArray() {
    this.endIndex = this.startIndex + this.getNumberOfItemVisible;
    if (this.endIndex > this.value.length) {
      this.endIndex = this.value.length;
    }
    this.displayedItems = this.value && this.value.length > 0 ? this.value.slice(this.startIndex, this.endIndex) : [];
    console.log(this.displayedItems);

    if (this.label === 'NET ALLOCATION') {

    }
    this.yardLocalStationSummary = this.generateData(this.yardLocalStationSummary);
    // Logic to get the NET ALLOCATION for the YARD AND LOCAL ribbion item
    // for(let i=0;i<this.displayedItems.length;i++) {
    //   if (this.displayedItems[i].type === 'NET ALLOCATION') {
    //     this.displayedItems[i] = this.generateData(this.displayedItems[i]);
    //   }
    // }
  }

  ngOnInit() {
    
  }

  ngOnChanges() {
   
  }

  /**
   * on prev  icon click
   * @memberof LmsCarouselComponent
   */
  onPrevNav() {
    this.startIndex--;
    if (this.startIndex < 0) {
      this.startIndex = 0;
    }
    this.adjustDisplayArray();
  }

  /**
   * On Next icon click
   * @memberof LmsCarouselComponent
   */
  onNextNav() {
    this.startIndex++;
    if (this.startIndex >= this.value.length) {
      this.startIndex = this.value.length - 1;
    }
    this.adjustDisplayArray();
  }

  /**
   * this is angular life cycle that will execute
   *  after view render on comonent
   * then we set which one is first visible
   * @memberof LmsCarouselComponent
   */
  ngAfterViewInit() {
    if (this.firstVisible && this.firstVisible > 0 && this.firstVisible <= this.value.length) {
      this.startIndex = this.firstVisible - 1;
    }
    this.calcuateDataWidth();
    console.log(this.displayedItems.length);
  }

  dblClickEvent(event) {
    if (this.lococlickdoubleclick.counter === 2) {
      this.lococlickdoubleclick.counter = 0;
      this.headerDblClick.emit(event);
      clearInterval(this.lococlickdoubleclick.timer);
    }
  }

  /**
   * on double click of any loco
   * then do related work
   * @param {any} loco
   * @param {any} event
   * @memberof LmsCarouselComponent
   */
  locoClickEvent(loco, event) {
    const obj = {
      data: loco,
      event: event
    };
    this.locoClick.emit(obj);
  }

  /**
   * Show Overlay data when click on station arraow.
   * @param {any} event
   * @param {OverlayPanel} panel
   * @param {StationDetail} stationDetail
   * @memberof LmsCarouselComponent
   */
  showOverlay(event, panel: OverlayPanel, stationDetail) {
    if (stationDetail && this.displayedItems.length) {
      //this.generateData(stationDetail);
      this.terminalOverlay = panel;
      panel.show(event);
    }
  }

  checkForblankLocoIdentifier(loco: LocoDetail) {
    return loco.locomotiveIdentifier.trim() === ''
  }
  
  generateData(stationDetail) {
    const totalLine = stationDetail.totalLine;
      if (totalLine && _.split(totalLine, ':').length >= 2) {
        const totalLineArr = _.split(_.split(totalLine, ':')[1], ',');
        for (let i = 0; i < totalLineArr.length; i++) {
          const a = _.split(totalLineArr[i], '=');
          switch (a[0] && a[0].trim()) {
            case 'Plan':
              stationDetail.plan = a[1] && a[1].trim();
              break;
            case 'Alloc':
              stationDetail.alloc = a[1] && a[1].trim();
              break;
            case 'Shop/Store/OOS(Pink)':
              stationDetail.shopStoreOOS = a[1] && a[1].trim();
              break;
            case 'Out Geo(Grey)':
              stationDetail.outGeo = a[1] && a[1].trim();
              break;
            case 'Net Alloc':
              if (a[1] && a[1].trim()) {
                stationDetail.netAlloc = a[1];
                const netAllocArr = a[1].split('(');
                if (netAllocArr && netAllocArr.length > 0) {
                  stationDetail.netAllocValue = netAllocArr[0];
                } else {
                  stationDetail.netAllocValue = a[1];
                }
              }
              break;
            case 'Other Y/L':
              stationDetail.otherYL = a[1] && a[1].trim();
              break;
            case 'Road':
              stationDetail.road = a[1] && a[1].trim();
              break;
            case 'Avail vs. Plan':
              stationDetail.availVsPlan = a[1] && a[1].trim();
              break;
          }
        }
      }
      return stationDetail;
  }

}
